import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
    selector: 'shared-prompt-confirmation',
    template: `
        <nb-card accent="primary">
            <nb-card-header>{{ content.title }}</nb-card-header>
            <nb-card-body *ngIf="content?.text"> {{ content.text }}</nb-card-body>
            <nb-card-footer>
                <button nbButton class="mr-2" (click)="closePrompt(false)">{{ 'GENERAL.NO' | translate }}</button>
                <button nbButton status="primary" (click)="closePrompt(true)">{{ 'GENERAL.YES' | translate }}</button>
            </nb-card-footer>
        </nb-card>
    `,
    styles: [``],
})
export class SharedPromptConfirmation implements OnInit {
    @Input() content: any;
    @Output() close: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    closePrompt(confirm) {
        this.close.emit(confirm);
    }
}
